import React from 'react';
import BSpinner from 'react-bootstrap/Spinner';
import 'bootstrap/dist/css/bootstrap.min.css';


export interface MyComponentProps {
  // Define your prop types here
}

export const Spinner: React.FC<MyComponentProps> = () => {
  return (
    <div className="spinner" style={{"padding": "20px 5px"}}>
      {/* <BSpinner animation="grow" role="status">
        <span className="sr-only">Loading...</span>
      </BSpinner> */}
      <BSpinner animation="grow" variant="primary" />
      <BSpinner animation="grow" variant="secondary" />
      <BSpinner animation="grow" variant="success" />
      <BSpinner animation="grow" variant="danger" />
      <BSpinner animation="grow" variant="warning" />
      <BSpinner animation="grow" variant="info" />
    </div>
  );
}

